import type { BookingProblem, Language, MapSpot } from '@kratispot/shared';
import { dayMonthOf } from '@/lib/format';

// What a sweep leaves selected: its first tile decided add or remove. See §10.
export function sweptSelection(
  current: ReadonlySet<string>,
  swept: Iterable<string>,
  adding: boolean,
): Set<string> {
  const next = new Set(current);
  for (const spotId of swept) {
    if (adding) next.add(spotId);
    else next.delete(spotId);
  }
  return next;
}

// Beyond a handful, a toast names the count; up to it, the spots themselves.
export const NAMED_SPOT_LIMIT = 3;

export function changedMessage(spots: readonly MapSpot[], one: string, many: string): string {
  if (spots.length > NAMED_SPOT_LIMIT || spots.length === 0) return `${spots.length} ${many}`;
  return `${one} · ${spots.map((spot) => `#${spot.number}`).join(', ')}`;
}

// §10: which spot, and which days of the range it is already taken on.
export function refusedMessage(
  problem: BookingProblem | null,
  language: Language,
  say: { reason: (problem: BookingProblem) => string; failed: string; onDays: string },
): string {
  if (problem === null) return say.failed;
  const spots = problem.spotNumbers.map((number) => `#${number}`).join(', ');
  const days = problem.days.map((day) => dayMonthOf(day, language)).join(', ');
  const when = days === '' ? '' : ` ${say.onDays} ${days}`;
  return `${say.reason(problem)} ${spots}${when}`;
}
